// extracted by mini-css-extract-plugin
export default {"buttonActive":"button_buttonActive__VVFjE","buttonInactive":"button_buttonInactive__Y0mEe"};